export const isDev = () => process.env.NX_NODE_ENV !== 'prod'

export const isProd = () => process.env.NX_NODE_ENV === 'prod'

export const isLocalhost = () => window.location.origin.includes('localhost')
